<template>
  <div>
    <div class="form-info" @mouseover="MostrarInfo" @mouseout="FecharInfo">
      ?
    </div>
    <div v-show="ativo" class="form-info-container" :id="'info-'+info">
      <div class="row">
        <div class="col-md-6">
          <img class="img-info" :src="img">
        </div>
        <div class="col-md-6">
          <h4 class="titulo-info">{{info}}</h4>
          <div class="img-desc" >{{desc}}</div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>


export default {
  name: 'Info',
  data () {
    return {
      ativo:false,
      desc:"",
      img:"",
      gancho:{
        desc:"Extensão entre a incisura jugular, passando pelo períneo (região dos órgãos genitais), contornando a região glútea até a sétima vértebra cervical (saliência óssea no limite entre o pescoço e o tronco traseiro).",
        img:"static/img/info/gancho.png"
      },
      quadril:{
        desc:"Extensão da linha entre a cintura e a sétima vértebra cervical (saliência óssea no limite entre o pescoço e o tronco traseiro), acompanhando o contorno das costas.",
        img:"static/img/info/quadril.png"
      },
      cintura:{
        desc:"Maior perímetro do quadril, passando pela região glútea (nádegas).",
        img:"static/img/info/cintura.png"
      },
      torax:{
        desc:"Perímetro do tronco no nível médio entre as costelas mais baixas e a crista superior do ilíaco.",
        img:"static/img/info/torax.png"
      }

    }
  },
  props:["info"],
  computed:{


  },
  created: function () {

  },
  methods:{
    MostrarInfo:function(){
      let ctx = this.info
      if(ctx == 'torax'){ this.img = this.torax.img; this.desc = this.torax.desc;}
      if(ctx == 'cintura'){ this.img = this.cintura.img; this.desc = this.cintura.desc;}
      if(ctx == 'quadril'){ this.img = this.quadril.img; this.desc = this.quadril.desc;}
      if(ctx == 'gancho'){ this.img = this.gancho.img; this.desc = this.gancho.desc;}
      $('#info-'+ctx).slideDown('ease')

    },
    FecharInfo:function(){
      $('.form-info-container').slideUp('ease')
    }

  }
}
</script>


<style >

.form-info{
  color:white;
  position: absolute;
  background-color: #dadada;
  /*padding: 5px;*/
  cursor: help;
  text-align: center;
  width: 25px;
  height: 25px;
  border-radius: 50px;
  right:10px;
  top: 10px;
  z-index: 100;
  transition: background-color 0.5s ease;
}
.form-info:hover{
  background-color: #e49142;

}
.form-info-container{
  display: none;
  position: absolute;
  border: 1px solid #dadada;
  background-color: white;
  right: 0px;
  top: 47px;
  z-index: 200;
  width: 100%;
  padding: 15px;
  border-radius: 0px 0px 5px 5px;
}
.img-info{
  max-width: 300px;
  width: 100%;
  height: auto;
}
.titulo-info{
  text-transform: capitalize;
}
</style>



// WEBPACK FOOTER //
// src/components/partes/Info.vue